.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  width: 100%;
}

.svg {
  width: 100%;
  height: 16rem;
  background: var(--tuna-surface-elevated);
  border-radius: var(--tuna-shape-borderRadius);
  border: 1px solid var(--tuna-border-subtle);
  touch-action: none;
}

.compact {
  height: 6rem;
}

/*
 * Row shading by key. The key is a HINT (§2): an out-of-key row is drawn quieter, never marked as
 * wrong, and a note may sit on it freely. WCAG 1.4.1 - the tonic also carries a data-row attribute
 * and a heavier top edge, so the three states are not distinguished by fill alone.
 */
.inKeyRow {
  fill: var(--tuna-surface-elevated);
}

/*
 * `--tuna-border-subtle`, not `--tuna-palette-grey-300`: the raw grey ramp is defined once and is
 * NOT redefined for dark mode, so a literal grey-300 would paint a bright band across a dark roll.
 */
.outOfKeyRow {
  fill: var(--tuna-border-subtle);
  opacity: 0.45;
}

.tonicRow {
  fill: var(--tuna-palette-info-light);
  opacity: 0.5;
}

.slotLine {
  stroke: var(--tuna-border-subtle);
  stroke-width: 0.15;
  opacity: 0.6;
}

.barLine {
  stroke: var(--tuna-content-secondary);
  stroke-width: 0.4;
  opacity: 0.7;
}

.insertSurface {
  fill: transparent;
  cursor: crosshair;
}

.note {
  fill: var(--tuna-palette-info-main);
  rx: 0.6;
}

.noteSelected {
  fill: var(--tuna-palette-info-dark);
  stroke: var(--tuna-content-primary);
  stroke-width: 0.4;
}

.noteGroup {
  cursor: pointer;
  outline: none;
}

.noteGroup:focus-visible .note {
  stroke: var(--tuna-content-primary);
  stroke-width: 0.5;
}

/* The offset nub: drag it to move the bar's drawn start off its gridline. */
.offsetHandle {
  fill: var(--tuna-feedback-warning);
  cursor: ew-resize;
}

.resizeHandle {
  fill: var(--tuna-content-secondary);
  cursor: ew-resize;
}

.playhead {
  stroke: var(--tuna-feedback-success);
  stroke-width: 0.5;
}

.cursor {
  stroke: var(--tuna-content-primary);
  stroke-width: 0.4;
  stroke-dasharray: 2 1.5;
}

.empty {
  color: var(--tuna-content-muted);
  font-size: var(--tuna-typography-body2-fontSize);
  padding: var(--tuna-spacing-2);
}
